module.exports = __webpack_public_path__ + "static/media/12.0e230748.jpeg";